import styled from 'styled-components'
// import styled, { css } from 'styled-components'
// import { Link } from 'gatsby'
// import { darken, lighten } from 'polished'
import { breakpoints, theme } from '../builderUtils/theme'

export const HeroSection = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  width: 100%;
  height: auto;
  background-color: ${theme.cream};
  @media (max-width: ${breakpoints.m}px) {
    display: flex;
    flex-direction: column;
  }
`
export const HeroCopyContainer = styled.div`
  width: 100%;
`

export const HeaderContainer = styled.header`
  grid-column: 1;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 96px;
  min-width: 240px;

  @media (max-width: ${breakpoints.m}px) {
    width: 100%;
    padding: 40px;
    padding-top: 0;
    padding-bottom: 10px;
  }
`

export const ContentWrapper = styled.div`
  overflow: hidden;
  color: ${theme.onboardGray};

  @media (max-width: ${breakpoints.m}px) {
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`

export const Headline = styled.h1`
  font-family: 'P22MackinacProBook';
  font-size: 63px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 75.6px */
  letter-spacing: -1.575px;

  @media (max-width: ${breakpoints.m}px) {
    font-size: 36px;
    font-style: normal;
    line-height: 120%; /* 43.2px */
    letter-spacing: -0.76px;
    text-align: center;
  }
`

export const Description = styled.p`
  font-family: 'FilsonPro';
  margin-top: 24px;
  font-size: 24px;
  font-weight: 400;
  line-height: 150%; /* 36px */

  @media (max-width: ${breakpoints.m}px) {
    font-size: 16px;
    text-align: center;
  }
`

export const CTAContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;

  margin-top: 35px;
  width: 100%;

  @media (max-width: ${breakpoints.m}px) {
    margin-top: 20px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`
export const MobileMediaContainer = styled.div`
  display: none;
  @media (max-width: ${breakpoints.m}px) {
    display: block;
  }
`

export const MediaContainer = styled.div`
  display: block;

  @media (max-width: ${breakpoints.m}px) {
    display: none;
  }
`
export const MediaContentContainer = styled.div`
  grid-column: 2;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  max-height: 100%;
  overflow: hidden;

  @media (max-width: ${breakpoints.m}px) {
  }
`
export const VideoContainer = styled.video`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  object-fit: fill;
  @media (max-width: ${breakpoints.m}px) {
    margin-bottom: 20px;
  }
`

export const ImageContainer = styled.div`
  /* aspect-ratio: 1.05; */
  height: 100%;
  width: 100%;
  min-width: 240px;

  @media (max-width: ${breakpoints.m}px) {
    width: 100%;
  }
`
export const StyledImage = styled.img`
  object-fit: contain;
  aspect-ratio: 1.05;
  height: 100%;
  width: 100%;
  @media (max-width: ${breakpoints.m}px) {
    width: 100%;
    height: 100%;
  }
`

// Maybe get rid of
// export const linkStyle = css`
//   font-family: 'FilsonPro';
//   background-color: ${(props) => props.theme.coral};
//   color: white;
//   text-decoration: none;
//   border-radius: 28px;
//   border: none;
//   font-size: 18px;
//   padding: 15px 30px;
//   letter-spacing: 0.09px;
//   &:hover {
//     cursor: pointer;
//     background-color: ${(props) => darken(0.1, props.theme.coral)};
//   }
//   &:focus {
//     outline: none;
//     box-shadow: ${(props) => `0 0 0 0.2rem ${lighten(0.1, props.theme.coral)}`};
//   }
//   @media (max-width: ${breakpoints.m}px) {
//     font-size: 16px;
//     letter-spacing: 0.08px;
//   }
//   @media (max-width: 375px) {
//     padding: 15px 16px;
//     font-size: 15px;
//   }
// `

// export const BuyNowLink = styled(Link)`
//   ${linkStyle}
//   background-color: ${(props) => props.theme.coral};
//   &:hover {
//     cursor: pointer;
//     background-color: ${(props) => darken(0.1, props.theme.coral)};
//   }
//   &:focus {
//     outline: none;
//     box-shadow: ${(props) => `0 0 0 0.2rem ${lighten(0.1, props.theme.coral)}`};
//   }
// `
